import { render, staticRenderFns } from "./AliyunUpload.vue?vue&type=template&id=30e13627&scoped=true"
import script from "./AliyunUpload.vue?vue&type=script&lang=js"
export * from "./AliyunUpload.vue?vue&type=script&lang=js"
import style0 from "./AliyunUpload.vue?vue&type=style&index=0&id=30e13627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e13627",
  null
  
)

export default component.exports